const computeGrowthRate = (current: number, prev: number) => {
    if (current - prev === 0) return 0;
    return 100 * ((current - prev) / Math.max(1, prev));
};

export default computeGrowthRate;
